<template>
  <div class="sidebar">
    <div class="sidebar-backdrop" @click="toggle" v-if="backdrop && isOpen"></div>
    <transition name="slide">
      <div v-if="isOpen"
        class="sidebar-panel"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    backdrop: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    }
  },
  computed: {
    isOpen() {
      return this.open
    }
  }
}
</script>
<style>

.slide-enter-active,
.slide-leave-active
{
  transition: transform 0.2s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  transition: all 150ms ease-in 0s
}

.sidebar-backdrop {
  background-color: rgba(0, 0, 0, 0.8);
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  cursor: pointer;
  z-index: 100;
}

.sidebar-panel {
  overflow-y: auto;
  background: #fff;
  position: fixed;
  left: 0;
  z-index: 999;
  padding: 0;
  height: 100%;
  padding: 25px;
  width: 75%;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue